var _circle, _mask, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBroken2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 234,
    viewBox: "0 0 234 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117,
    cy: 117,
    r: 117,
    fill: "#D9E5E9"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 234,
    height: 234
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 117,
    cy: 117,
    r: 117,
    fill: "#D9E5E9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251 130.5L165 63L116 175L202.5 235.5L218.5 227.5L251 130.5Z",
    fill: "#189adc",
    fillOpacity: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.627 97.7743C181.665 77.6879 166.964 61.0996 148.958 61.0996C137.489 61.0996 127.621 67.2781 122.087 71.6354C119.073 74.0085 117.343 75.8421 117.343 75.8421C117.343 75.8421 104.238 61.0996 85.7274 61.0996C67.7227 61.0996 53.0209 77.6877 52.0588 97.774C51.5161 109.121 54.79 117.755 59.4049 125.578C68.6221 141.204 117.403 172.901 117.403 172.901C117.403 172.901 117.627 172.755 118.046 172.48C123.806 168.698 166.631 140.272 175.281 125.578C179.906 117.72 183.17 109.121 182.627 97.7743Z",
    fill: "url(#paint0_linear)",
    stroke: "#050E2C",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 125,
    width: 5,
    height: 9,
    rx: 2.5,
    fill: "#050E2C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 125,
    width: 5,
    height: 9,
    rx: 2.5,
    fill: "#050E2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.406 133.87C115.899 131.271 119.083 131.396 124.598 133.87",
    stroke: "#050E2C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5 62L161.5 74.5L145.5 87.5L156 109",
    stroke: "#050E2C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.839 94.5056L167.03 90.3145C169.332 88.0128 169.332 84.2809 167.03 81.9792H167.03C164.728 79.6775 160.996 79.6775 158.695 81.9792L154.504 86.1703L162.839 94.5056Z",
    fill: "#DD9E40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.167 94.5054L141.976 98.6965C139.675 100.998 139.675 104.73 141.976 107.032V107.032C144.278 109.334 148.01 109.334 150.312 107.032L154.503 102.841L146.167 94.5054Z",
    fill: "#DD9E40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.963 81.9956C144.262 79.6907 147.994 79.6859 150.298 81.9847L167.038 98.6802C169.342 100.979 169.347 104.711 167.049 107.015C164.75 109.32 161.018 109.325 158.713 107.026L141.974 90.3309C139.669 88.0324 139.664 84.3005 141.963 81.9956Z",
    fill: "#FFDAAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.079 81.8797C142.04 81.9175 142 81.956 141.961 81.9951C139.662 84.2999 139.667 88.0318 141.972 90.3304L158.711 107.026C161.016 109.325 164.748 109.32 167.047 107.015C167.064 106.998 167.08 106.981 167.097 106.964L142.079 81.8797Z",
    fill: "#F4BA64"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 77.4727,
    y1: 77.2065,
    x2: 146.982,
    y2: 163.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484770"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 136,
    fill: "white",
    transform: "translate(49 49)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroken2);
export default __webpack_public_path__ + "static/media/broken_2.62f453330094718433beadb8543f513f.svg";
export { ForwardRef as ReactComponent };